module.exports = {
  foreground_color: '#000000',
  foreground_color_2: '#00ae11',
  is_gradient: false,
  gradient_angle: 0,
  is_radial_gradient: false,

  logo_url: null,
  version: '1',
  size: 240,
  background_color: '#FFFFFF',
  // frame
  frame_svg: null,
  frame_color: '#000000',
  frame_color_2: '#434343',
  frame_font: "Roboto",
  frame_text: "SCAN ME",

  // markers
  custom_marker_color: false,
  marker_left_inner_color: '#000000',
  marker_left_outer_color: '#000000',
  marker_right_inner_color: '#000000',
  marker_right_outer_color: '#000000',
  marker_bottom_inner_color: '#000000',
  marker_bottom_outer_color: '#000000',

  marker_left_svg: null,
  marker_right_svg: null,
  marker_bottom_svg: null,

//  only for image support
  image_url: null,
  background_image_url: null,
}